// extracted by mini-css-extract-plugin
export default {"main":"befda067ed","tit":"_867532cfa3","maintitle":"ad56e91ec0","ylw":"_079adbc206","white":"c9aa9b810c","mv_title":"ca5ec8a422","mv_nc":"efb055a25c","mv_in":"_457220b3e2"};